module.exports = __webpack_public_path__ + "media/images/apple_sign-91a1f1aadc026d99b7cc4cf7bc4d3ba6.png";